export const TRANSACTION_TYPES = [
  {
    value: "INCOME",
    label: "Pendapatan",
    debitLabel: "Simpan ke",
    creditLabel: "Diterima dari",
    // Penjualan kredit memakai akun yang berbeda, jadi labelnya ikut berbeda:
    // yang didebit adalah piutang, bukan kas, dan pendapatannya baru diakui —
    // belum diterima. Label yang tetap "Simpan ke" bertentangan dengan pilihan
    // akun yang tersisa setelah difilter.
    debitUnpaidLabel: "Akun piutang",
    creditUnpaidLabel: "Diakui sebagai",
    debitAccounts: ["CASH_AND_BANK", "INVENTORY"],
    creditAccounts: ["INCOME", "OTHER_INCOME"],
    debitUnpaidAccounts: ["ACCOUNTS_RECEIVABLE"],
    creditUnpaidAccounts: ["INCOME", "OTHER_INCOME"],
    style: {
      colorClass: "bg-green-100 text-green-800",
      textColorClass: "text-green-600",
      prefix: "+",
    },
  },
  {
    value: "EXPENSE",
    label: "Pengeluaran",
    debitLabel: "Untuk biaya",
    creditLabel: "Diambil dari",
    // Pembelian kredit mendebit akun yang sama, tapi mengkredit utang — belum
    // ada kas yang diambil.
    debitUnpaidLabel: "Untuk biaya",
    creditUnpaidLabel: "Akun hutang",
    debitAccounts: [
      "COST_OF_GOODS_SOLD",
      "EXPENSE",
      "OTHER_EXPENSE",
      "INVENTORY",
      "CASH_AND_BANK",
      "ACCOUNTS_RECEIVABLE",
      "FIXED_ASSETS",
    ],
    creditAccounts: [
      "CASH_AND_BANK",
      "INVENTORY",
      "OTHER_CURRENT_ASSETS",
      "FIXED_ASSETS",
      "OTHER_ASSETS",
    ],
    debitUnpaidAccounts: [
      "COST_OF_GOODS_SOLD",
      "EXPENSE",
      "OTHER_EXPENSE",
      "INVENTORY",
      "CASH_AND_BANK",
      "ACCOUNTS_RECEIVABLE",
      "FIXED_ASSETS",
    ],
    creditUnpaidAccounts: [
      "ACCOUNTS_PAYABLE",
      "OTHER_CURRENT_LIABILITIES",
      "LONG_TERM_OBLIGATION",
    ],
    style: {
      colorClass: "bg-red-100 text-red-800",
      textColorClass: "text-red-600",
      prefix: "-",
    },
  },
  {
    value: "INVESTMENT",
    label: "Tanam Modal",
    debitLabel: "Simpan ke",
    creditLabel: "Modal",
    debitAccounts: ["CASH_AND_BANK"],
    creditAccounts: ["CAPITAL"],
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-blue-100 text-blue-800",
      textColorClass: "text-blue-600",
      prefix: "+",
    },
  },
  {
    value: "DIVESTMENT",
    label: "Tarik Modal",
    debitLabel: "Modal",
    creditLabel: "Diambil dari",
    debitAccounts: ["CAPITAL"],
    creditAccounts: ["CASH_AND_BANK"],
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-orange-100 text-orange-800",
      textColorClass: "text-orange-600",
      prefix: "-",
    },
  },
  {
    value: "TRANSFER",
    label: "Transfer",
    debitLabel: "Ke",
    creditLabel: "Diambil dari",
    debitAccounts: ["CASH_AND_BANK"],
    creditAccounts: ["CASH_AND_BANK"],
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-purple-100 text-purple-800",
      textColorClass: "text-purple-600",
      prefix: "",
    },
  },
  {
    value: "RECEIVABLE",
    label: "Piutang",
    debitLabel: "Akun piutang",
    creditLabel: "Diterima dari",
    debitAccounts: ["ACCOUNTS_RECEIVABLE"],
    creditAccounts: [
      "CASH_AND_BANK",
      "INVENTORY",
      "OTHER_CURRENT_ASSETS",
      "INCOME",
      "OTHER_INCOME",
      "CAPITAL",
    ],
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-yellow-100 text-yellow-800",
      textColorClass: "text-yellow-600",
      prefix: "+",
    },
  },
  {
    value: "PAYABLE",
    label: "Hutang",
    debitLabel: "Untuk biaya",
    creditLabel: "Akun hutang",
    debitAccounts: [
      "COST_OF_GOODS_SOLD",
      "EXPENSE",
      "OTHER_EXPENSE",
      "INVENTORY",
      "OTHER_CURRENT_ASSETS",
      "FIXED_ASSETS",
      "CASH_AND_BANK",
    ],
    creditAccounts: [
      "ACCOUNTS_PAYABLE",
      "OTHER_CURRENT_LIABILITIES",
      "LONG_TERM_OBLIGATION",
    ],
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-pink-100 text-pink-800",
      textColorClass: "text-pink-600",
      prefix: "-",
    },
  },
  {
    value: "INCOME_RECEIVABLE",
    label: "Piutang Pendapatan",
    debitLabel: "Akun piutang",
    creditLabel: "Diterima dari",
    debitAccounts: ["ACCOUNTS_RECEIVABLE"],
    creditAccounts: ["INCOME", "OTHER_INCOME"],
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-green-100 text-green-800",
      textColorClass: "text-green-600",
      prefix: "+",
    },
  },
  {
    value: "EXPENSE_PAYABLE",
    label: "Hutang Pengeluaran",
    debitLabel: "Untuk biaya",
    creditLabel: "Akun hutang",
    debitAccounts: [
      "COST_OF_GOODS_SOLD",
      "EXPENSE",
      "OTHER_EXPENSE",
      "INVENTORY",
      "CASH_AND_BANK",
      "ACCOUNTS_RECEIVABLE",
      "FIXED_ASSETS",
    ],
    creditAccounts: [
      "ACCOUNTS_PAYABLE",
      "OTHER_CURRENT_LIABILITIES",
      "LONG_TERM_OBLIGATION",
    ],
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-red-100 text-red-800",
      textColorClass: "text-red-600",
      prefix: "-",
    },
  },
  {
    value: "ASSET_ACQUISITION",
    label: "Perolehan Aset",
    systemGenerated: true,
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-blue-100 text-blue-800",
      textColorClass: "text-blue-600",
      prefix: "",
    },
  },
  {
    value: "ASSET_DISPOSAL",
    label: "Pelepasan Aset",
    systemGenerated: true,
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-orange-100 text-orange-800",
      textColorClass: "text-orange-600",
      prefix: "",
    },
  },
  // Sales deposits are written through /deposit only, never this form.
  {
    value: "SALES_DEPOSIT",
    label: "Uang Muka Penjualan",
    systemGenerated: true,
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-purple-100 text-purple-800",
      textColorClass: "text-purple-600",
      prefix: "+",
    },
  },
  {
    value: "SALES_DEPOSIT_APPLICATION",
    label: "Pemakaian Uang Muka",
    systemGenerated: true,
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-purple-100 text-purple-800",
      textColorClass: "text-purple-600",
      prefix: "",
    },
  },
  {
    value: "SALES_DEPOSIT_REFUND",
    label: "Pengembalian Uang Muka",
    systemGenerated: true,
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-purple-100 text-purple-800",
      textColorClass: "text-purple-600",
      prefix: "-",
    },
  },
  {
    value: "SALES_DEPOSIT_FORFEIT",
    label: "Uang Muka Hangus",
    systemGenerated: true,
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-purple-100 text-purple-800",
      textColorClass: "text-purple-600",
      prefix: "",
    },
  },
  {
    value: "OTHER",
    label: "Lainnya",
    debitUnpaidAccounts: [],
    creditUnpaidAccounts: [],
    style: {
      colorClass: "bg-gray-100 text-gray-800",
      textColorClass: "text-gray-600",
      prefix: "",
    },
  },
];

export const ACCOUNT_CATEGORY_OPTIONS = [
  {
    label: "Cash & Bank",
    value: "CASH_AND_BANK",
  },
  {
    label: "Accounts Receivable",
    value: "ACCOUNTS_RECEIVABLE",
  },
  {
    label: "Inventory",
    value: "INVENTORY",
  },
  {
    label: "Other Current Assets",
    value: "OTHER_CURRENT_ASSETS",
  },
  {
    label: "Fixed Assets",
    value: "FIXED_ASSETS",
  },
  {
    label: "Other Assets",
    value: "OTHER_ASSETS",
  },
  {
    label: "Depreciation & Amortization",
    value: "DEPRECIATION_AND_AMORTIZATION",
  },
  {
    label: "Account Payable",
    value: "ACCOUNTS_PAYABLE",
  },
  {
    label: "Other Current Liabilities",
    value: "OTHER_CURRENT_LIABILITIES",
  },
  {
    label: "Long Term Obligation",
    value: "LONG_TERM_OBLIGATION",
  },
  {
    label: "Capital",
    value: "CAPITAL",
  },
  {
    label: "Income",
    value: "INCOME",
  },
  {
    label: "Cost Of Goods Sold",
    value: "COST_OF_GOODS_SOLD",
  },
  {
    label: "Expense",
    value: "EXPENSE",
  },
  {
    label: "Other Income",
    value: "OTHER_INCOME",
  },
  {
    label: "Other Expense",
    value: "OTHER_EXPENSE",
  },
];

export const ACCOUNT_CODE = {
  CASH_AND_BANK: "110",
  ACCOUNTS_RECEIVABLE: "110",
  INVENTORY: "110",
  OTHER_CURRENT_ASSETS: "110",
  FIXED_ASSETS: "110",
  OTHER_ASSETS: "110",
  DEPRECIATION_AND_AMORTIZATION: "110",
  ACCOUNTS_PAYABLE: "220",
  OTHER_CURRENT_LIABILITIES: "220",
  LONG_TERM_OBLIGATION: "220",
  CAPITAL: "330",
  INCOME: "440",
  COST_OF_GOODS_SOLD: "550",
  EXPENSE: "660",
  OTHER_INCOME: "770",
  OTHER_EXPENSE: "990",
};

export const TRANSACTION_OPTIONS = [
  {
    value: "accounting-transaction",
    label: "Transaction",
  },
  {
    value: "invoice",
    label: "Invoice",
  },
];

export const PAYMENT_TYPES = [
  { value: true, label: "transactions.statusPayment.paid" },
  { value: false, label: "transactions.statusPayment.notPaid" },
];

export const partnerTransactionTypes = [
  "INCOME",
  "EXPENSE",
  "INCOME_RECEIVABLE",
  "EXPENSE_PAYABLE",
  "PAYABLE",
  "RECEIVABLE",
];
